import { Sparkles, Mail } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Global footer with brand, quick links, and feedback email.
 * Styled to the Afro Sci-Fi dark theme with gold + cyan accents.
 */
export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="relative border-t border-[#F2C94C]/15 bg-[#0A0A0A] mt-24"
    >
      {/* Top accent line */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#F2C94C]/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#F2C94C] to-[#FF6B4A] flex items-center justify-center shadow-[0_0_20px_-6px_rgba(242,201,76,0.55)]">
              <Sparkles className="w-5 h-5 text-[#0A0A0A]" />
            </div>
            <div className="leading-none">
              <div className="font-display text-lg tracking-tight text-white">GENEO AI</div>
              <div className="font-mono-hy text-[9px] text-[#F2C94C] tracking-widest">AFRO SCI-FI · ANIMATION</div>
            </div>
          </div>
          <p className="font-body text-sm text-white leading-relaxed max-w-xs">
            Create cinematic Afro Sci-Fi characters, animations, and voiceovers — all in one studio.
          </p>
        </div>

        {/* Quick links */}
        <div>
          <div className="font-mono-hy text-[10px] text-[#F2C94C] tracking-widest mb-4">// STUDIO</div>
          <ul className="space-y-2.5 font-body text-sm">
            <li><Link to="/studio" data-testid="footer-link-studio" className="text-[#D9D2BE] hover:text-[#F2C94C] transition-colors">Studio</Link></li>
            <li><Link to="/gallery" data-testid="footer-link-gallery" className="text-[#D9D2BE] hover:text-[#F2C94C] transition-colors">Gallery</Link></li>
            <li><Link to="/storyboard" data-testid="footer-link-storyboard" className="text-[#D9D2BE] hover:text-[#F2C94C] transition-colors">Storyboard</Link></li>
            <li><Link to="/pricing" data-testid="footer-link-pricing" className="text-[#D9D2BE] hover:text-[#F2C94C] transition-colors">Pricing</Link></li>
          </ul>
        </div>

        {/* Feedback */}
        <div>
          <div className="font-mono-hy text-[10px] text-[#00E5FF] tracking-widest mb-4">// FEEDBACK</div>
          <p className="font-body text-sm text-[#D9D2BE] leading-relaxed mb-3">
            Ideas, bug reports, feature requests, partnerships — we read every message.
          </p>
          <a
            href="mailto:geneo@afrogeneo.com"
            data-testid="footer-feedback-link"
            className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-[#F2C94C]/30 bg-[#F2C94C]/5 hover:bg-[#F2C94C]/15 hover:border-[#F2C94C] transition-all"
          >
            <Mail className="w-4 h-4 text-[#F2C94C]" />
            <span className="font-mono-hy text-[11px] text-[#F2C94C] tracking-wider group-hover:text-[#F2D06B]">
              geneo@afrogeneo.com
            </span>
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#F2C94C]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="font-mono-hy text-[9px] text-white tracking-widest">
            © {new Date().getFullYear()} GENEO AI · NANO·BANANA × SEEDANCE × ELEVENLABS
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00E5FF]" />
            <span className="font-mono-hy text-[9px] text-[#00E5FF] tracking-widest">LIVE FROM THE DYNASTY</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
